export default {"src":"/_next/static/media/ice_climbing.99ad275f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};